import * as types from '../mutation-types'
import actionsRepository from '../../api/actionsRepository'

const state = {
  actionToCreate: {},
  actions: [],
  isActionCreated: false,
  isActionDeleted: false
}

const getters = {
  actionToCreate: state => state.actionToCreate,
  actions: state => state.actions,
  isActionCreated: state => state.isActionCreated,
  isActionDeleted: state => state.isActionDeleted
}

const actions = {
  getActions ({commit}) {
    return actionsRepository.getActions().then((response) => {
      commit(types.SET_ACTIONS, response.data)
    })
  },
  createAction ({commit}) {
    return actionsRepository.createAction(state.actionToCreate).then((response) => {
      if (response.data.success) {
        commit(types.SET_ACTION_CREATED, true)
        commit(types.ADD_ACTION_TO_ACTIONS, response.data)
      } else {
        commit(types.SET_ACTION_CREATED, false)
      }
    })
  },
  deleteAction ({commit}, actionId) {
    return actionsRepository.deleteAction(actionId).then((response) => {
      if (response.data.success) {
        commit(types.SET_ACTION_DELETED, true)
      } else {
        commit(types.SET_ACTION_DELETED, false)
      }
    })
  }
}

const mutations = {
  [types.SET_ACTION_TO_CREATE] (state, payload) {
    state.actionToCreate = payload
  },
  [types.SET_ACTIONS] (state, payload) {
    state.actions = payload
  },
  [types.SET_ACTION_CREATED] (state, payload) {
    state.isActionCreated = payload
  },
  [types.SET_ACTION_DELETED] (state, payload) {
    state.isActionDeleted = payload
  },
  [types.ADD_ACTION_TO_ACTIONS] (state, payload) {
    state.actions.push(payload.message)
  },
  [types.REMOVE_ACTIONS_FROM_ACTIONS] (state, payload) {
    state.actions.forEach((action, index) => {
      if (action.id === payload) {
        state.actions.splice(index, 1)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
